import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { arrayMove } from '@dnd-kit/sortable';
export const ITEM_RADIUS_VARIABLE = '--draggable-grid-item-radius';
export const readInheritedItemStyle = (element)=>{
    const computed = getComputedStyle(element);
    return {
        fontFamily: computed.fontFamily,
        fontSize: computed.fontSize,
        fontWeight: computed.fontWeight,
        lineHeight: computed.lineHeight,
        letterSpacing: computed.letterSpacing,
        color: computed.color,
        itemRadius: computed.getPropertyValue(ITEM_RADIUS_VARIABLE).trim()
    };
};
export const toOverlayStyle = (_0)=>{
    let { itemRadius } = _0, inherited = _object_without_properties(_0, [
        "itemRadius"
    ]);
    return Object.fromEntries(Object.entries(_object_spread_props(_object_spread({}, inherited), {
        [ITEM_RADIUS_VARIABLE]: itemRadius
    })).filter((param)=>{
        let [, value] = param;
        return value;
    }));
};
export const reorderItems = (items, activeId, overId)=>{
    const oldIndex = items.findIndex((item)=>item.id === activeId);
    const newIndex = items.findIndex((item)=>item.id === overId);
    if (oldIndex === -1 || newIndex === -1) {
        return items;
    }
    return arrayMove(items, oldIndex, newIndex);
};
const lockToRowAxis = (param)=>{
    let { transform } = param;
    return _object_spread_props(_object_spread({}, transform), {
        y: 0
    });
};
const isSingleRow = (layout)=>'rows' in layout && layout.rows === 1;
export const resolveDragModifiers = (layout)=>isSingleRow(layout) ? [
        lockToRowAxis
    ] : [];
